import React, { useState } from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import { IRescheduleNotify } from '../dto/IPlanner';
import { useTranslation } from 'react-i18next';
import { plannerInfluencer } from '../../../../store/influencer/plannerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { FaEllipsisV } from 'react-icons/fa';
import { IAllStates } from '../../../../store/rootReducer';
import { UserRoles } from '../../../../enum/UserRoles';
import { AcceptIcon, DeclineIcon } from '../../../../shared/Icons';
import { formatDate } from '../../../../shared/functions/Functions';

interface IRescheduleCardProps {
    rescheduleData: IRescheduleNotify;
    openModalActions?: (eventId: number, isApproveAction: boolean) => void;
}

export function RescheduleCard({ rescheduleData, openModalActions }: IRescheduleCardProps) {
    const userType = useSelector((state: IAllStates) => state.auth.user.userType);
    const isBrandUser = userType === UserRoles.BRAND_MASTER || userType === UserRoles.BRAND;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const openModal = () => {
        dispatch(
            plannerInfluencer.actions.setOpenPreviewModal({
                eventId: rescheduleData?.event?.id,
                isOpenPreviewEventModal: true,
            })
        );
    };
    return (
        <Card className="reschedule-card mb-3">
            <div
                className="d-flex align-items-center justify-content-between"
                onClick={event => {
                    event.stopPropagation();
                    openModal();
                }}
            >
                <div className="d-flex align-items-center">
                    <img className="social-icon mr-2" src={rescheduleData.event.offerItem.socialPlatform.path ?? ''} />
                    <div>
                        <h6 className="mb-0">{rescheduleData?.event?.offerItem?.offer?.campaign?.title}</h6>
                        <p className="mb-0 text-info">
                            {t('influencer.planner.rescheduleTo')} {formatDate(rescheduleData?.postingDate)}
                        </p>
                    </div>
                </div>
                {!isBrandUser && (
                    <Dropdown
                        onClick={event => {
                            event.stopPropagation();
                        }}
                    >
                        <Dropdown.Toggle className="mr-2" variant="light" id="dropdown-basic">
                            <FaEllipsisV className="text-secondary" />
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => openModalActions && openModalActions(rescheduleData?.event?.id, true)}
                            >
                                <div className="d-flex align-items-center">
                                    <i className="fi fi-rr-check font-20 me-2"></i>
                                    {t('general.button.accept')}
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item
                                onClick={() => openModalActions && openModalActions(rescheduleData?.event?.id, false)}
                                className="text-danger"
                            >
                                <DeclineIcon width={20} height={20} className="me-2" />
                                {t('general.button.decline')}
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                )}
            </div>
        </Card>
    );
}
